import React from "react";
import "./OnDemandSolutions.css";
import { Link } from "react-router-dom";
import {
  FaCarSide,
  FaHamburger,
  FaShoppingCart,
  FaCut,
  FaDumbbell,
  FaGraduationCap,
  FaHeartbeat,
  FaHome,
  FaPlane,
  FaTruck,
  FaStore,
  FaCreditCard,
} from "react-icons/fa";

const OnDemandSolutions = () => {
  const cards = [
    {
      title: "Ride Sharing",
      icon: FaCarSide,
      desc: "AI-powered ride matching, dynamic pricing, GPS tracking, and real-time driver-passenger management for seamless mobility experiences.",
    },
    {
      title: "Food Delivery",
      icon: FaHamburger,
      desc: "Smart restaurant discovery, order management, live delivery tracking, and route optimization built for faster fulfillment and better customer retention.",
    },
    {
      title: "Grocery Delivery",
      icon: FaShoppingCart,
      desc: "End-to-end grocery delivery platforms with inventory management, personalized recommendations, and hyperlocal delivery workflows.",
    },
    {
      title: "Logistics & Courier",
      icon: FaTruck,
      desc: "Advanced logistics platforms with route optimization, fleet management dashboards, shipment tracking, and operational analytics.",
    },
    {
      title: "Beauty & Salon",
      icon: FaCut,
      desc: "Appointment booking systems with smart scheduling, stylist allocation, service management, and customer engagement tools.",
    },
    {
      title: "Home Services",
      icon: FaHome,
      desc: "Scalable service marketplaces with provider matching, scheduling, real-time tracking, and payment integrations.",
    },
    {
      title: "Healthcare",
      icon: FaHeartbeat,
      desc: "Digital healthcare solutions including appointment booking, AI-assisted symptom support, doctor discovery, and patient management systems.",
    },
    {
      title: "E-Learning",
      icon: FaGraduationCap,
      desc: "Interactive learning platforms with adaptive content delivery, student dashboards, course management, and engagement tools.",
    },
    {
      title: "Fitness On-Demand",
      icon: FaDumbbell,
      desc: "Personalized fitness platforms with virtual training sessions, progress tracking, subscription plans, and workout recommendations.",
    },
    {
      title: "Travel & Booking",
      icon: FaPlane,
      desc: "Smart booking platforms with itinerary management, dynamic pricing, availability systems, and seamless reservation workflows.",
    },
    {
      title: "Fintech & Payment Solutions",
      icon: FaCreditCard,
      desc: " Secure fintech applications with wallet systems, payment gateway integrations, transaction monitoring, and financial dashboards.",
    },
    {
      title: "Rental & Marketplace Solutions",
      icon: FaStore,
      desc: "Multi-vendor marketplace and rental platforms with booking systems, vendor management, payments, and user-friendly workflows.",
    },
  ];

  return (
    <section className="on-demand-section">
      <div className="on-demand-container">
        {/* Header */}
        <div className="on-demand-header">
          <h4 className="sub-title">High-Demand Solutions</h4>

          <h2 className="on-demand-title split-lines">
            On-Demand Platforms Powered <br />
            by AI & Scalable Technology
          </h2>
          <p className="">
            Launch, manage, and scale your on-demand business with intelligent,
            ready-to-deploy solutions built for speed, automation, and long-term
            growth
          </p>
          <p className="">
            From mobility and delivery to healthcare and marketplace platforms,
            we build high-performance systems designed to scale seamlessly with
            your business.
          </p>
        </div>

        {/* Grid */}
        <div className="on-demand-grid">
          {cards.map((card, index) => {
            const Icon = card.icon;
            return (
              <div key={index} className="on-demand-card">
                <div className="on-demand-card-glow"></div>

                <div className="on-demand-card-icon">
                  <Icon size={22} />
                </div>

                <h3 className="on-demand-card-title">{card.title}</h3>
                <p className="on-demand-card-desc">{card.desc}</p>

                <div className="on-demand-divider"></div>

                <span className="on-demand-subtext">{card.sub}</span>
              </div>
            );
          })}
        </div>

        {/* Last Card */}
        {/* <div className="on-demand-last-row">
          {(() => {
            const Icon = lastCard.icon;
            return (
              <div className="on-demand-card">
                <div className="on-demand-card-glow"></div>

                <div className="on-demand-card-icon">
                  <Icon size={22} />
                </div>

                <h3 className="on-demand-card-title">{lastCard.title}</h3>
                <p className="on-demand-card-desc">{lastCard.desc}</p>

                <div className="on-demand-divider"></div>

                <span className="on-demand-subtext">{lastCard.sub}</span>
              </div>
            );
          })()}
        </div> */}

        {/* CTA */}
        <div className="on-demand-cta">
          <h3>Build Your Own On-Demand Platform</h3>
          <p>
            Turn your idea into a scalable, high-performance digital product
            with expert guidance, modern architecture, and future-ready
            technology.
          </p>
          <div className="gap-3 d-flex justify-content-center">
            <Link to="/contact-us" className="cta-btn">
              Start Your Project
            </Link>
            <Link to="#" className="cta-btn cta-secondary">
              Talk to Our Experts
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnDemandSolutions;
